<template>
    <div class="section cycle-calc">
        <div class="container">
            <div class="info">
                <h4 class="white-text weight-med center-text">What time do you want to start your cycle?</h4>
                <p class="small-body light-text center-text">Time is in a 24 hour format, for example: "22:30" is 10:30pm</p>
                <div class="form-container">
                  <div class="form">
                    <form @submit.prevent>
                      <input type="time" @keydown.tab="calculate" v-model="time" min="00:00" max="23:59">
                      <button class="btn" @click="calculate">
                          <p class="accent-colour">Submit</p>
                      </button>
                    </form>
                  </div>
                </div>

            </div>

            <div class="results" v-if="sleeps.length > 0">

                <div class="column">
                    <p class="light-shade-text weight-med center-text">Sleep</p>

                    <div class="result-line" v-for="(sleep, index) in sleeps" :key="index">
                        <p class="white-text">Start sleep {{index + 1}} at <strong>{{sleep}}</strong></p>
                    </div>
                </div>
                <div class="column">
                    <p class="light-shade-text weight-med center-text">Duration</p>

                    <div class="result-line" v-for="(duration, index) in durations" :key="index">
                        <p class="white-text"><strong>{{duration}}</strong> Hours</p>
                    </div>
                </div>
                <div class="column">
                    <p class="light-shade-text weight-med center-text">Wake</p>

                    <div class="result-line" v-for="(wake, index) in wakes" :key="index">
                        <p class="white-text">Set alarm {{index + 1}} for <strong>{{wake}}</strong></p>
                    </div>
                </div>
                
            </div>

            <div class="sub-info">
                <p class="small-body light-text center-text">
                    We recommend using a tool such as google calendar to remind you when you should start going to sleep and an alarm to wake you up on time. Usually adapting to a new schedule takes 2-4 weeks before you start to notice a difference. If you try it and don’t feel it is for you, try another one out and see if it fits better.
                </p>
            </div>

            <div class="twitter-sharing">
              <social-sharing 
              v-bind:url="this.url"
              v-bind:title="this.title"
              description=""
              quote=""
              hashtags="sleep, productivity, startup, SlumberBear"
              twitter-user=""
              inline-template>
                <div>
                    <network network="twitter">
                      <button class="twitter-share-button">
                        <span class="twitter-text">
                          <img src="@/assets/twitter-logo-silhouette.svg" class="twitter-icon">
                            Share This Calculator
                        </span>
                      </button>
                    </network>
                </div>
              </social-sharing>
            </div>


        </div>
    </div>
</template>

<script>
export default {
  name: "CycleCalculator",
  props: {
    msg: String
  },

  data() {
    return {
      sleeps: [],
      durations: [],
      wakes: [],
      time: null,
      url: this.$route.query.page,
      title:
        "I just figured out my 🛌 " +
        this.msg +
        " 🛌 by using this tool created by @_kprkr 👉"
    };
  },

  methods: {
    calculate() {
      if (this.time) {
        this.sleeps = [];
        this.durations = [];
        this.wakes = [];

        if (this.$route.name === "MonophasicCycle") {
          // Convert a time in hh:mm format to minutes
          function timeToMins(time) {
            var b = time.split(":");
            return b[0] * 60 + +b[1];
          }

          // Convert minutes to a time in format hh:mm
          // Returned value is in range 00  to 24 hrs
          function timeFromMins(mins) {
            function z(n) {
              return (n < 10 ? "0" : "") + n;
            }
            var h = ((mins / 60) | 0) % 24;
            var m = mins % 60;
            return z(h) + ":" + z(m);
          }

          // Add two times in hh:mm format
          function addTimes(t0, t1) {
            return timeFromMins(timeToMins(t0) + timeToMins(t1));
          }

          let sleep1 = this.time;
          let duration1 = "08:00";
          let wake1 = addTimes(this.time, duration1);

          this.sleeps.push(sleep1);
          this.durations.push(duration1);
          this.wakes.push(wake1);
        } else if (this.$route.name === "BiphasicCycle") {
          // Convert a time in hh:mm format to minutes
          function timeToMins(time) {
            var b = time.split(":");
            return b[0] * 60 + +b[1];
          }

          // Convert minutes to a time in format hh:mm
          // Returned value is in range 00  to 24 hrs
          function timeFromMins(mins) {
            function z(n) {
              return (n < 10 ? "0" : "") + n;
            }
            var h = ((mins / 60) | 0) % 24;
            var m = mins % 60;
            return z(h) + ":" + z(m);
          }

          // Add two times in hh:mm format
          function addTimes(t0, t1) {
            return timeFromMins(timeToMins(t0) + timeToMins(t1));
          }

          let sleep1 = this.time;
          let duration1 = "06:00";
          let wake1 = addTimes(this.time, duration1);

          this.sleeps.push(sleep1);
          this.durations.push(duration1);
          this.wakes.push(wake1);

          let sleep2 = addTimes(this.time, "12:00");
          let duration2 = "01:30";
          let wake2 = addTimes(sleep2, duration2);

          this.sleeps.push(sleep2);
          this.durations.push(duration2);
          this.wakes.push(wake2);
        } else if (this.$route.name === "EverymanCycle") {
          // Convert a time in hh:mm format to minutes
          function timeToMins(time) {
            var b = time.split(":");
            return b[0] * 60 + +b[1];
          }

          // Convert minutes to a time in format hh:mm
          // Returned value is in range 00  to 24 hrs
          function timeFromMins(mins) {
            function z(n) {
              return (n < 10 ? "0" : "") + n;
            }
            var h = ((mins / 60) | 0) % 24;
            var m = mins % 60;
            return z(h) + ":" + z(m);
          }

          // Add two times in hh:mm format
          function addTimes(t0, t1) {
            return timeFromMins(timeToMins(t0) + timeToMins(t1));
          }

          let sleep1 = this.time;
          let duration1 = "03:30";
          let wake1 = addTimes(this.time, duration1);

          let interval1 = "05:00";
          let duration2 = "00:20";

          let sleep2 = addTimes(wake1, interval1);
          let wake2 = addTimes(sleep2, duration2);

          let sleep3 = addTimes(wake2, interval1);
          let wake3 = addTimes(sleep3, duration2);

          let sleep4 = addTimes(wake3, interval1);
          let wake4 = addTimes(sleep4, duration2);

          this.sleeps.push(sleep1, sleep2, sleep3, sleep4);
          this.durations.push(duration1, duration2, duration2, duration2);
          this.wakes.push(wake1, wake2, wake3, wake4);
        } else if (this.$route.name === "DymaxionCycle") {
          // Convert a time in hh:mm format to minutes
          function timeToMins(time) {
            var b = time.split(":");
            return b[0] * 60 + +b[1];
          }

          // Convert minutes to a time in format hh:mm
          // Returned value is in range 00  to 24 hrs
          function timeFromMins(mins) {
            function z(n) {
              return (n < 10 ? "0" : "") + n;
            }
            var h = ((mins / 60) | 0) % 24;
            var m = mins % 60;
            return z(h) + ":" + z(m);
          }

          // Add two times in hh:mm format
          function addTimes(t0, t1) {
            return timeFromMins(timeToMins(t0) + timeToMins(t1));
          }

          let sleep1 = this.time;
          let duration1 = "00:30";
          let wake1 = addTimes(this.time, duration1);
          let interval1 = "05:30";

          let sleep2 = addTimes(wake1, interval1);
          let wake2 = addTimes(sleep2, duration1);

          let sleep3 = addTimes(wake2, interval1);
          let wake3 = addTimes(sleep3, duration1);

          let sleep4 = addTimes(wake3, interval1);
          let wake4 = addTimes(sleep4, duration1);

          this.sleeps.push(sleep1, sleep2, sleep3, sleep4);
          this.durations.push(duration1, duration1, duration1, duration1);
          this.wakes.push(wake1, wake2, wake3, wake4);
        } else if (this.$route.name === "UbermanCycle") {
          // Convert a time in hh:mm format to minutes
          function timeToMins(time) {
            var b = time.split(":");
            return b[0] * 60 + +b[1];
          }

          // Convert minutes to a time in format hh:mm
          // Returned value is in range 00  to 24 hrs
          function timeFromMins(mins) {
            function z(n) {
              return (n < 10 ? "0" : "") + n;
            }
            var h = ((mins / 60) | 0) % 24;
            var m = mins % 60;
            return z(h) + ":" + z(m);
          }

          // Add two times in hh:mm format
          function addTimes(t0, t1) {
            return timeFromMins(timeToMins(t0) + timeToMins(t1));
          }

          let sleep1 = this.time;
          let duration1 = "00:20";
          let wake1 = addTimes(this.time, duration1);
          let interval1 = "03:40";

          let sleep2 = addTimes(wake1, interval1);
          let wake2 = addTimes(sleep2, duration1);

          let sleep3 = addTimes(wake2, interval1);
          let wake3 = addTimes(sleep3, duration1);

          let sleep4 = addTimes(wake3, interval1);
          let wake4 = addTimes(sleep4, duration1);

          let sleep5 = addTimes(wake4, interval1);
          let wake5 = addTimes(sleep5, duration1);

          let sleep6 = addTimes(wake5, interval1);
          let wake6 = addTimes(sleep6, duration1);

          this.sleeps.push(sleep1, sleep2, sleep3, sleep4, sleep5, sleep6);
          this.durations.push(
            duration1,
            duration1,
            duration1,
            duration1,
            duration1,
            duration1
          );
          this.wakes.push(wake1, wake2, wake3, wake4, wake5, wake6);
        }

        // end of calcs
      }
    }
  },

  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.url = this.$route.query.page;
      }
    };
  }
};
</script>

<style lang="scss">
@import "@/styles/global.scss";

.cycle-calc {
  background-color: $main-colour;
}

.twitter-text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 4px;
  height: 100%;
  margin-right: 10px;
  margin-left: 10px;
}

.twitter-sharing {
  margin-top: 40px;
}

.twitter-sharing h5 {
  margin-right: 10px;
}

.cycle-calc .container {
  padding: 100px 0px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.cycle-calc h4 {
  width: 64%;
  @media only screen and (max-width: $tablet) {
    width: 80%;
  }
}

.cycle-calc .info {
  margin-bottom: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  @media only screen and (max-width: $tablet) {
    -webkit-margin-after: 0px;
  }
}

.cycle-calc ul {
  list-style: none;
  font-size: 18px;
  color: white;
  margin-top: 6px;
}

.cycle-calc li {
  margin-bottom: 14px;
  line-height: 20px;
}

.cycle-calc .results {
  width: 70%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-preferred-size: 30%;
  flex-basis: 30%;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;

  @media only screen and (max-width: $mobile) {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 80%;
  }
}

.cycle-calc .sub-info {
  width: 64%;
  margin-top: 100px;
  -webkit-margin-before: 10px;
  @media only screen and (max-width: $tablet) {
    margin-top: 60px;
    width: 80%;
  }
}

.cycle-calc .form {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 40px;
}

.cycle-calc button {
  padding: 0px 30px;
  margin-left: 24px;
  color: $accent-colour;
}

.cycle-calc .column {
  // width: 30%;

  @media only screen and (max-width: $tablet) {
    margin-bottom: 30px;
    width: auto;
  }
}

.cycle-calc .column:nth-last-child(1) {
  @media only screen and (max-width: $tablet) {
    margin-bottom: 0px;
  }
}

.cycle-calc .result-line {
  margin-top: 6px;
  text-align: center;
}

.cycle-calc input[type="time"] {
  height: 100%;
}

.form-container {
  height: 60px;
  margin-top: 40px;
  -webkit-margin-after: 60px;
}
</style>
